const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLdreomsorgBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "aldreomsorg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.17 249.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "border",
    d: "M83.53,57.5s-2.17,2-2.8,9.32,3.14,17.73.9,20.23S70,111.29,67.34,112,48,115.26,46.81,117.33s-14,5.74-17.91,8.49-6.44,5.94-6.2,12.15.24,24.11.24,24.11-15.18.71-15.85,3,7.51,32.57,4.79,34.41S1.59,206.82.44,215.32,3.41,227,8,230.71s14.49,3.34,20,7.53,17,15,25,8.54S59,229,66.08,227.16s28-1.42,30.55.9,11.69,5.65,18.81,4.27,10.43-6,17.84-6,35.17,1.17,36.78-1.14-2.17-70,1.84-72.55c5.72-3.59,14.46-8,14-12.61s-22.57-47.13-18.85-50.78,9-4.15,6.92-11.11-9.8-23.59-8.46-27.22,5.15-14.65.38-19.58-15.78-.43-18.77-10S143.36,1,134.22.27,117.74,20.69,115.44,20,104.16,9.38,91.55,17.22,79.85,38.78,80.08,43.85,83.53,57.5,83.53,57.5Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdreomsorgBorder);
export default __webpack_public_path__ + "static/media/äldreomsorg-border.90709e733afe777ea8eb2e61785045b1.svg";
export { ForwardRef as ReactComponent };